import _ from 'lodash';

import api from '../api';
import infoBoard from '../core/infoboard';
import templates from '../core/templates';
import { FeaturePermission } from '../../constants/feature.permission.helper';

const urls = {};

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

let $container = null;
let $page = null;

const _showReports = (options = {}) => {
  const $content = $(templates('dashboard-view-no-header', {
    title: 'Report',
    subtitle: $page,
    url: options.url || urls.reports
  }));
  $content.appendTo($container);
  $content.find('iframe').show();
};

const _createContainer = (type, url) => {
  $container = $('#dash-container');
  $container.empty();
  return _showReports({ url });
};

class ReportControl {
  constructor () {
    const $button = $('#trigger-dashboard');
    if (isAuthorized(FeaturePermission.SYSTEM.showNeodash)) {
      $button.show();
    }
  }

  static getInstance () {
    if (!ReportControl._instance) {
      ReportControl._instance = new ReportControl();
    }

    return ReportControl._instance;
  }

  show (type, url) {
    url = _.replace(url, new RegExp('{user}', 'g'), _.escape(sessionStorage.username));

    _createContainer(type, url);
    infoBoard.toggleDashboard(true, 'up');
  }

  init () {
  }

  check () {
    return true;
  }

  get () {
    return null;
  }
}

export default ReportControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/ReportControl.js